import documentIcon from '../../img/svgs/document.svg';
import cardIcon from '../../img/svgs/payment/contentCard.svg';
import globeIcon from '../../img/svgs/contentGlobe.svg';
import doctorIcon from '../../img/svgs/doctor.svg';
import {
  CASCO_COMPENSATION_PATH,
  CLAIM_STATUS_PATH,
  MEDICAL_COMPENSATION_PATH,
  RECURRING_SCHEDULE_PATH,
} from '../../constants/routes';

export const services = {
  first: {
    link: CLAIM_STATUS_PATH,
    icon: documentIcon,
  },
  second: {
    link: RECURRING_SCHEDULE_PATH,
    icon: cardIcon,
  },
  third: {
    link: `${CASCO_COMPENSATION_PATH}/searchApplicant`,
    icon: globeIcon,
  },
  fourth: {
    link: `${MEDICAL_COMPENSATION_PATH}/searchApplicant`,
    icon: doctorIcon,
  },
};

export default services;
